var exports = {
  "I": "GitHubAvatar_0__hSNUie",
  "D": "Box_0__FjnsCt",
};

module.exports = exports;
